const useFooterDefaultOptions = () => {
  const defaultOptions = {
    form: false,
    submitLabel: "Enviar",
    labelBack: "Cancelar",
    defaultBack: null,
    submitButtonComponent: null,
    backRoute: null,
    showFooter: true,
    variation: null,
    notDeveloped: false
  };

  return {
    defaultOptions,
  };
};

export default useFooterDefaultOptions;
